import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { device } from '../utils/breakpoints';

const Banner = styled.aside`
  background: #7f1d1d;
  color: #ffffff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px 14px;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;

  @media ${device.phoneWide} {
    padding: 12px 16px;
    font-size: 13px;
  }
`;

const Tag = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background: #fbbf24;
  color: #451a03;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
`;

const Message = styled.span`
  max-width: 820px;
`;

const Action = styled(Link)`
  color: #ffffff;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 2px;
  white-space: nowrap;
`;

const SecurityAdvisoryBanner = () => (
  <Banner aria-label="Security advisory">
    <Inner>
      <Tag>Security advisory</Tag>
      <Message>
        <strong>PHP2Shell</strong> (CVE-2026-109618, CVE-2026-109619) affects PHP 5.4 and later -
        including WordPress, Nextcloud and Matomo. Patch the PHP runtime; an application update is
        not enough.
      </Message>
      <Action to="/blog/php2shell-critical-php-vulnerability">Read the advisory &rarr;</Action>
    </Inner>
  </Banner>
);

export default SecurityAdvisoryBanner;
